import { render, staticRenderFns } from "./method.vue?vue&type=template&id=cf0c5d1e&scoped=true&"
import script from "./method.vue?vue&type=script&lang=js&"
export * from "./method.vue?vue&type=script&lang=js&"
import style0 from "./method.vue?vue&type=style&index=0&id=cf0c5d1e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf0c5d1e",
  null
  
)

export default component.exports